var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdk2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "744px",
    height: "650px",
    viewBox: "0 0 744 650",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-42.9%",
    y: "-42.9%",
    width: "185.7%",
    height: "185.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-42.9%",
    y: "-42.9%",
    width: "185.7%",
    height: "185.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "0.0%",
    y: "0.0%",
    width: "100.0%",
    height: "100.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "0.0%",
    y: "0.0%",
    width: "100.0%",
    height: "100.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "StaFihub",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u843D\\u5730\\u7248\\u672C1",
    transform: "translate(12.000000, -1372.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(138.000000, 1522.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-23-Copy-2",
    fill: "#FFD5E2",
    opacity: 0.3,
    filter: "url(#filter-1)",
    cx: 269,
    cy: 175,
    r: 175
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-23-Copy-3",
    fill: "#6758FF",
    opacity: 0.3,
    filter: "url(#filter-2)",
    cx: 175,
    cy: 175,
    r: 175
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(72.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.169666,148.071979 L278.046272,148.071979 C288.041349,148.071979 296.143959,156.17459 296.143959,166.169666 L296.143959,208.907533 L296.143959,208.907533 C312.008539,201.198091 319.940828,205.598236 319.940828,222.107969 C319.940828,238.617702 312.008539,242.524431 296.143959,233.828157 L296.143959,278.002471 C296.143959,287.997547 288.041349,296.100157 278.046272,296.100157 C278.03169,296.100157 278.017107,296.10014 278.002524,296.100105 L232.291022,295.989604 L232.291022,295.989604 C241.932873,311.698831 238.753684,319.553445 222.753453,319.553445 C206.753222,319.553445 202.897636,311.750283 211.186694,296.143959 L166.169666,296.143959 C156.17459,296.143959 148.071979,288.041349 148.071979,278.046272 L148.071979,166.169666 C148.071979,156.17459 156.17459,148.071979 166.169666,148.071979 Z",
    id: "Rectangle-17-Copy-4",
    fill: "#6758FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-25-Copy-23",
    opacity: 0.817708333,
    transform: "translate(196.606684, 180.976864)",
    fill: "#020204"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-14",
    points: "24.6786632 0 49.3573265 41.6207614 24.6786632 56.8000979 0 42.1104174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-14-Copy",
    points: "24.6786632 0 24.6786632 31.8276411 24.6786632 56.8000979 0 42.1104174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-18",
    points: "24.6786632 31.3379851 49.3573265 41.6207614 24.6786632 56.8000979 0 42.1104174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-18-Copy",
    points: "24.6786632 31.3379851 24.6786632 41.6207614 24.6786632 56.8000979 0 42.1104174"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-28",
    points: "0 47.0069776 24.6786632 61.6966581 49.3573265 47.0069776 24.6786632 82.2622108 14.2271548 67.3314844"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-28-Copy",
    points: "0 47.0069776 24.6786632 61.6966581 24.6786632 82.2622108"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M166.169666,0 L278.046272,0 C288.041349,1.71664797e-15 296.143959,8.10261018 296.143959,18.0976864 L296.143959,60.8355539 L296.143959,60.8355539 C312.008539,53.1261113 319.940828,57.5262566 319.940828,74.0359897 C319.940828,90.5457228 312.008539,94.4524521 296.143959,85.7561774 L296.143959,129.930492 C296.143959,139.925568 288.041349,148.028178 278.046272,148.028178 C278.03169,148.028178 278.017107,148.02816 278.002524,148.028125 L232.291022,147.917624 L232.291022,147.917624 C241.932873,163.626852 238.753684,171.481466 222.753453,171.481466 C206.753222,171.481466 202.897636,163.678303 211.186694,148.071979 L166.169666,148.071979 C156.17459,148.071979 148.071979,139.969369 148.071979,129.974293 L148.071979,18.0976864 C148.071979,8.10261018 156.17459,1.83606571e-15 166.169666,0 Z",
    id: "Rectangle-17-Copy",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.865637,82.1343629 C230.359047,82.1343629 238.865637,75.955488 238.865637,72.3656371 C238.865637,68.7757862 230.359047,65.8656371 219.865637,65.8656371 C209.372227,65.8656371 200.865637,68.7757862 200.865637,72.3656371 C200.865637,75.955488 209.372227,82.1343629 219.865637,82.1343629 Z",
    id: "Oval-26-Copy",
    fill: "#FF7FA7",
    filter: "url(#filter-3)",
    transform: "translate(219.865637, 74.000000) rotate(-270.000000) translate(-219.865637, -74.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0976864,148.071979 L129.974293,148.071979 C139.969369,148.071979 148.071979,156.17459 148.071979,166.169666 L148.071979,208.907533 L148.071979,208.907533 C163.936559,201.198091 171.868849,205.598236 171.868849,222.107969 C171.868849,238.617702 163.936559,242.524431 148.071979,233.828157 L148.071979,278.046272 C148.071979,288.041349 139.969369,296.143959 129.974293,296.143959 L18.0976864,296.143959 C8.10261018,296.143959 1.45401603e-14,288.041349 0,278.046272 L0,166.169666 C-1.22404381e-15,156.17459 8.10261018,148.071979 18.0976864,148.071979 Z",
    id: "Rectangle-17-Copy-6",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73,230 C83.4934102,230 92,227.089851 92,223.5 C92,219.910149 83.4934102,214.111439 73,214.111439 C62.5065898,214.111439 54,219.910149 54,223.5 C54,227.089851 62.5065898,230 73,230 Z",
    id: "Oval-26",
    fill: "#6758FF",
    filter: "url(#filter-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0976864,0 L129.974332,0 C139.969408,-1.83606571e-15 148.072018,8.10261018 148.072018,18.0976864 L148.072018,60.8355926 L148.072018,60.8355926 C163.936598,53.12615 171.868888,57.5262953 171.868888,74.0360284 C171.868888,90.5457615 163.936598,94.4524907 148.072018,85.7562161 L148.072018,130.019222 C148.072018,139.99675 139.996775,148.092073 130.019277,148.116852 L84.3993117,148.23015 L84.3993117,148.23015 C89.5613318,160.210384 86.1069041,166.2005 74.0360284,166.2005 C61.9651527,166.2005 58.4811009,160.157673 63.583873,148.072018 L18.0976864,148.072018 C8.10261018,148.072018 -7.34266756e-14,139.969408 0,129.974332 L0,18.0976864 C-1.22404381e-15,8.10261018 8.10261018,-1.71664797e-15 18.0976864,0 Z",
    id: "Rectangle-17",
    fill: "#FF7FA7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-2",
    transform: "translate(32.904884, 33.727506)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-13",
    stroke: "#000002",
    strokeWidth: 3.29048843,
    fill: "#E54C87",
    cx: 41.1311054,
    cy: 41.1311054,
    r: 42.7763496
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-13-Copy",
    fill: "#FFFFFF",
    cx: 41.1311054,
    cy: 41.1311054,
    r: 28.7917738
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1311054,0 C63.8471877,0 82.2622108,18.4150231 82.2622108,41.1311054 L82.2622108,41.1311054 L71.5681234,41.1311054 L71.5681234,41.1311054 C71.5681234,23.7886102 58.1516436,9.57970184 41.131722,8.31741819 Z",
    id: "Combined-Shape",
    stroke: "#003C6A",
    strokeWidth: 0.822622108,
    fill: "#FF7FA7"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#FF7FA7",
    points: "61 64 88 83 61 83"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdk2);
export default __webpack_public_path__ + "static/media/sdk2.0715de8f662d40d5a6ab27bb9b5cf9a2.svg";
export { ForwardRef as ReactComponent };